<app-ng-dynamic-breadcrumb
  [symbol]="'>'"
  [bgColor]="'transparent'"
  [fontSize]="'15px'"
  [fontColor]="'#161c24'"
  [lastLinkColor]="'#323639'"
>
</app-ng-dynamic-breadcrumb>
<router-outlet></router-outlet>
